import { render } from "./legoDropdownExtend.vue?vue&type=template&id=28887243&scoped=true"
import script from "./legoDropdownExtend.vue?vue&type=script&lang=js"
export * from "./legoDropdownExtend.vue?vue&type=script&lang=js"

import "./legoDropdownExtend.vue?vue&type=style&index=0&id=28887243&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28887243"],['__file',"src/components/lego/extend/legoDropdownExtend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28887243"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28887243', __exports__)) {
    api.reload('28887243', __exports__)
  }
  
  module.hot.accept("./legoDropdownExtend.vue?vue&type=template&id=28887243&scoped=true", () => {
    api.rerender('28887243', render)
  })

}


export default __exports__